// Central configuration for external links & brand info.
// Update these when domains/contacts change.

export const SITE = {
    domain: "https://newbraunfelsfootball.com",
    brand: "PUSATCUAN",
};

// Target URL for Daftar / Login / main CTAs.
export const DAFTAR_URL = "https://pusatcuan.app/login";
export const LOGIN_URL = "https://pusatcuan.app/login";

// WhatsApp floating button.
// Replace WA_NUMBER with the real CS number (international format, no +, no spaces).
export const WA_NUMBER = "62812978444";
export const WA_MESSAGE =
    "Halo PUSATCUAN, saya ingin info link resmi terpercaya & bantuan daftar.";
export const WA_URL = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;
